// Qué segmentos se ofrecen como destino de una promo y cómo se avisa cuando no llegaron.
import type { SalePromotionSegment } from '../api/promotionsContract';
import type { PromotionsAvailability } from './promotionsFormat';

const SEGMENTS_NOTICE: Partial<Record<PromotionsAvailability, string>> = {
    loading: 'Cargando segmentos…',
    forbidden: 'No tienes permiso para leer los segmentos de las promos.',
    failed: 'No pudimos leer los segmentos. Intenta de nuevo en un momento.',
    unavailable: 'Los segmentos no están disponibles en este ambiente.',
};

/** Sin el catch-all: ya agarra a todos los que no están en otro segmento. */
export function pickableSegments(
    segments: readonly SalePromotionSegment[],
): SalePromotionSegment[] {
    return segments.filter((segment) => !segment.isDefault);
}

/** La frase bajo los chips de segmentos; `undefined` cuando llegaron bien. */
export function segmentsNotice(state: PromotionsAvailability): string | undefined {
    return SEGMENTS_NOTICE[state];
}
